define([
	"dojo/_base/declare",
	"csi/xml",
	"./PasteForm"
], function(declare,xml,PasteForm) {

	var SAMPLEACTUAL_INDEX = "SizeChartPasteSampleActualIndex";
	var EXP1 = "validValue('SizeChartPasteData')";
	var EXP2 = "!" + EXP1;

	return declare(PasteForm, {
		_hideExpressions: {
			// Display or hide fields based on input Paste Data field
			SizeChartPasteData: EXP1,
			SizeChartPasteUnits: EXP2,
			SizeChartPasteDimensionIndex: EXP2,
			SizeChartPasteDimensionAttr: EXP2,
			SizeChartPasteSampleActualIndex: EXP2
		},

		// Memory: stores for selecting indices in pasted data
		_sampleActualStore: null,

		getFieldStore: function(/*Field*/field, /*String*/value) {
			// summary: return stores for fields
			switch(field.m_name) {
				case SAMPLEACTUAL_INDEX: return this._sampleActualStore || this._dummyStore;
			}

			return this.inherited(arguments);
		},

		_createStoresForIndexFields: function(/*Map*/colsByIndex) {
			// Called by _onWatchData() to create stores for index-type fields
			this.inherited(arguments);
			this._sampleActualStore = this._createStoreForIndexField(SAMPLEACTUAL_INDEX, colsByIndex, true);
		},

		_resolveView: function() {
			// summary: set initial values for fields
			this.addDefaultValue(this.UNITS, this._getUnitsDefaultValue());
			this.addDefaultValue(this.ADIM, xml.ATTR_NAME);
			this.inherited(arguments);
        }
	});
});